export const commaFormat = (num, isRoundUp = false, isFloat = false, toFixed = false) => {
  let value = isRoundUp ? Math.ceil(num) : Math.round(num);
  if (isFloat) {
    return parseFloat(value).toLocaleString(undefined, {
      maximumFractionDigits: 2,
    });
  }
  if (toFixed) {
    return num.toLocaleString(undefined, {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    })
  } else if (toFixed !== false && toFixed >= 1) {
    return num.toLocaleString(undefined, {
      minimumFractionDigits: toFixed,
      maximumFractionDigits: toFixed,
    })
  }
  return parseInt(value).toLocaleString(undefined, {
    maximumFractionDigits: 2,
  });
};

export const commaFixedFormat = (num, toFixed = 2) => {
  return commaFormat(num, false, false, toFixed);
}

export const formatNumericSting = (cover) => {
  try {
    // scan having any numeric inside string if no just return string
    if (!/\d/gi.test(cover)) return cover;

    // scan if having no wording found return formatted numeric
    if (!/(?!^\d+$)^.+$/gi.test(cover)) return commaFormat(cover);

    // separated out by replacing digits and text
    const string = cover.replace(/\d/gi, "");
    const numeric = cover.replace(/\D/gi, "");

    // return both of them with formatted
    return `${commaFormat(+numeric)}${string}`;
  } catch (err) {
    console.warn("couldn't format numeric string string", err);
  }
};
